import { Accordion, AccordionTab } from "primereact/accordion";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { OrderList } from "primereact/orderlist";
import { SelectButton } from "primereact/selectbutton";
import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ToastContext } from "../../../App";
import {useMobile} from '../../../hooks/useMobile'
import { useGetStationListQuery } from "../../../redux/services/foodStation";
import {
  useCreateOptionGroupMutation,
  useCreateOptionMutation,
  useDeleteOptionGroupMutation,
  useDeleteOptionMutation,
  useLazyGetStationOptionsListQuery,
  useSaveGroupOrderMutation,
  useSaveOptionsOrderMutation,
  useUpdateOptionGroupMutation,
  useUpdateOptionMutation,
  useUploadImageMutation,
} from "../../../redux/services/foodStationOptions";
import { setLoading } from "../../../redux/slices/app.slice";
import getSubdomain from "../../../utils/getSubdomain";

import NoImg from "../../../assets/no_img.svg";

import * as styles from "./MenuItems.module.css";

const MenuItems = () => {
  const showToast = useContext(ToastContext);
  const dispatch = useDispatch();
  const {isMobile} = useMobile(1024)

  const {
    data: stations,
    isSuccess: isGetStationsSuccess,
    isError: isGetStationsError,
  } = useGetStationListQuery(getSubdomain());

  const [
    getStationOptions,
    {
      data: stationOptions,
      isSuccess: isGetStationOptionsSuccess,
      isError: isGetStationOptionsError,
    },
  ] = useLazyGetStationOptionsListQuery();

  const [
    saveGroupOrder,
    {
      isSuccess: isSaveGroupOrderSuccess,
      isError: isSaveGroupOrderError,
      error: saveGroupOrderError,
    },
  ] = useSaveGroupOrderMutation();

  const [
    createOptionGroup,
    {
      isSuccess: isCreateOptionGroupSuccess,
      isError: isCreateOptionGroupError,
      error: createOptionGroupError,
    },
  ] = useCreateOptionGroupMutation();

  const [
    updateOptionGroup,
    {
      isSuccess: isUpdateOptionGroupSuccess,
      isError: isUpdateOptionGroupError,
      error: updateOptionGroupError,
    },
  ] = useUpdateOptionGroupMutation();

  const [
    deleteOptionGroup,
    {
      isSuccess: isDeleteOptionGroupSuccess,
      isError: isDeleteOptionGroupError,
      error: deleteOptionGroupError,
    },
  ] = useDeleteOptionGroupMutation();

  const [
    createOption,
    {
      isSuccess: isCreateOptionSuccess,
      isError: isCreateOptionError,
      error: createOptionError,
    },
  ] = useCreateOptionMutation();

  const [
    updateOption,
    {
      isSuccess: isUpdateOptionSuccess,
      isError: isUpdateOptionError,
      error: updateOptionError,
    },
  ] = useUpdateOptionMutation();

  const [
    saveOptionsOrder,
    {
      isSuccess: isSaveOptionsOrderSuccess,
      isError: isSaveOptionsOrdersError,
      error: saveOptionsOrdersError,
    },
  ] = useSaveOptionsOrderMutation();

  const [
    deleteOption,
    {
      isSuccess: isDeleteOptionSuccess,
      isError: isDeleteOptionError,
      error: deleteOptionError,
    },
  ] = useDeleteOptionMutation();

  const [
    uploadImage,
    {
      isSuccess: isUploadImageSuccess,
      isError: isUploadImageError,
      error: uploadImageError,
    },
  ] = useUploadImageMutation();

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      title: "",
    },
  });

  const {
    control: control2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
  } = useForm();

  const multiple = watch("multiple");

  const [selectedStation, setSelectedStation] = useState(null);
  const [openedAcc, setOpenedAcc] = useState(null);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [groupId, setGroupId] = useState(null);
  const [groupName, setGroupName] = useState(null);
  const [groupMode, setGroupMode] = useState(null);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [optionId, setOptionId] = useState(null);
  const [optionName, setOptionName] = useState(null);
  const [showDeleteOptionModal, setShowDeleteOptionModal] = useState(false);
  const [showOptionModal, setShowOptionModal] = useState(false);
  const [optionMode, setOptionMode] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [menuItem, setMenuItem] = useState(null);

  useEffect(() => {
    if (isGetStationsError) {
      showToast("error", "Station", "Unable to load stations");
      dispatch(setLoading(false));
    }
  }, [isGetStationsError]);

  useEffect(() => {
    if (selectedStation) {
      getStationOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
    }
  }, [selectedStation]);

  useEffect(() => {
    if (isGetStationOptionsError) {
      showToast("error", "Station Option", "Unable to load station options");
      dispatch(setLoading(false));
    }
  }, [isGetStationOptionsError]);

  useEffect(() => {
    if (isSaveGroupOrderSuccess)
      showToast("success", "Groups", "Order updated!");
  }, [isSaveGroupOrderSuccess]);

  useEffect(() => {
    if (isSaveGroupOrderError)
      showToast(
        "error",
        saveGroupOrderError?.status,
        saveGroupOrderError?.data?.message ||
          (saveGroupOrderError?.data?.errors && "Incorrect data")
      );
  }, [isSaveGroupOrderError]);

  useEffect(() => {
    if (isCreateOptionGroupSuccess) {
      showToast("success", "Group", "Group created!");
      setShowGroupModal(false);
    }
  }, [isCreateOptionGroupSuccess]);

  useEffect(() => {
    if (isUpdateOptionGroupSuccess) {
      showToast("success", "Group", "Group updated!");
      setShowGroupModal(false);
    }
  }, [isUpdateOptionGroupSuccess]);

  useEffect(() => {
    if (isCreateOptionGroupError)
      showToast(
        "error",
        createOptionGroupError?.status,
        createOptionGroupError?.data?.message ||
          (createOptionGroupError?.data?.errors && "Incorrect data")
      );
  }, [isCreateOptionGroupError]);

  useEffect(() => {
    if (isUpdateOptionGroupError)
      showToast(
        "error",
        updateOptionGroupError?.status,
        updateOptionGroupError?.data?.message ||
          (updateOptionGroupError?.data?.errors && "Incorrect data")
      );
  }, [isUpdateOptionGroupError]);

  useEffect(() => {
    if (isDeleteOptionGroupSuccess) {
      showToast("success", "Group", "Group deleted!");
      setShowDeleteGroupModal(false);
    }
  }, [isDeleteOptionGroupSuccess]);

  useEffect(() => {
    if (isDeleteOptionGroupError)
      showToast(
        "error",
        deleteOptionGroupError?.status,
        deleteOptionGroupError?.data?.message
      );
  }, [isDeleteOptionGroupError]);

  useEffect(() => {
    if (isCreateOptionSuccess) {
      showToast("success", "Option", "Option created!");
      setShowOptionModal(false);
    }
  }, [isCreateOptionSuccess]);

  useEffect(() => {
    if (isCreateOptionError) {
      showToast(
        "error",
        createOptionError?.status,
        createOptionError?.data?.message ||
          (createOptionError?.data?.errors && "Incorrect data")
      );
    }
  }, [isCreateOptionError]);

  useEffect(() => {
    if (isUpdateOptionSuccess) {
      showToast("success", "Option", "Option updated!");
      setShowOptionModal(false);
    }
  }, [isUpdateOptionSuccess]);

  useEffect(() => {
    if (isUpdateOptionError)
      showToast(
        "error",
        updateOptionError?.status,
        updateOptionError?.data?.message ||
          (updateOptionError?.data?.errors && "Incorrect data")
      );
  }, [isUpdateOptionError]);

  useEffect(() => {
    if (isSaveOptionsOrderSuccess)
      showToast("success", "Options", "Order updated!");
  }, [isSaveOptionsOrderSuccess]);

  useEffect(() => {
    if (isSaveOptionsOrdersError)
      showToast(
        "error",
        saveOptionsOrdersError?.status,
        saveOptionsOrdersError?.data?.message ||
          (saveOptionsOrdersError?.data?.errors && "Incorrect data")
      );
  }, [isSaveOptionsOrdersError]);

  useEffect(() => {
    if (isDeleteOptionSuccess) {
      showToast("success", "Option", "Option deleted!");
      setShowDeleteOptionModal(false);
    }
  }, [isDeleteOptionSuccess]);

  useEffect(() => {
    if (isDeleteOptionError)
      showToast(
        "error",
        deleteOptionError?.status,
        deleteOptionError?.data?.message
      );
  }, [isDeleteOptionError]);

  useEffect(() => {
    if (isUploadImageSuccess) {
      setShowImageModal(false);
      showToast("success", "Option", "Image uploaded!");
    }
  }, [isUploadImageSuccess]);

  useEffect(() => {
    if (isUploadImageError)
      showToast(
        "error",
        uploadImageError?.status,
        uploadImageError?.data?.message ||
          (uploadImageError?.data?.errors && "Incorrect data")
      );
  }, [isUploadImageError]);

  const openGroupModal = (mode, rowData) => (e) => {
    if (mode === "create") {
      setGroupId(null);
      setValue("title", "");
      setValue("multiple", "Single Choice");
      setValue("max_multiple", { value: 2 });
    } else {
      setGroupId(rowData.group_id);
      setValue("title", rowData.group_name);
      setValue(
        "multiple",
        rowData.allow_multiple ? "Multiple Choice" : "Single Choice"
      );
      setValue("max_multiple", { value: rowData.max_multiple });
    }
    setShowGroupModal(true);
    setGroupMode(mode);
  };

  const openGroupDeleteModal = (rowData) => (e) => {
    setGroupId(rowData.group_id);
    setGroupName(rowData.group_name);
    setShowDeleteGroupModal(true);
  };

  const openItemModal = (mode, rowData, groupData) => (e) => {
    console.log(rowData, groupData);
    if (mode === "create") {
      setOptionId(null);
      setValue2("item_title", "");
      setValue2("item_active", "");
      setValue2("item_cost", "");
      setValue2("item_note", "");
      console.log(rowData);
      setGroupName(rowData.group_name);
      setGroupId(rowData.group_id);
    } else {
      setOptionId(rowData.id);
      setGroupId(groupData.group_id || groupData.group.group_id);
      setValue2("item_title", rowData.name);
      setValue2("item_active", rowData.visible ? "Active" : "Inactive");
      setValue2("item_cost", rowData.cost);
      setValue2("item_note", rowData.note);
      setGroupName(groupData.group_name || groupData.group.group_name);
    }
    setShowOptionModal(true);
    setOptionMode(mode);
  };

  const openOptionDeleteModal = (rowData) => (e) => {
    setOptionId(rowData.id);
    setOptionName(rowData.name);
    setShowDeleteOptionModal(true);
  };

  const onCreate = (data) => {
    createOptionGroup({
      subdomain: getSubdomain(),
      name: data.title,
      station_id: selectedStation.id,
      allow_multiple: data.multiple !== "Single Choice",
      max_multiple:
        data.multiple === "Multiple Choice" ? +data.max_multiple.value : null,
    });
  };

  const onSaveEdit = (data) => {
    updateOptionGroup({
      id: groupId,
      data: {
        name: data.title,
        allow_multiple: data.multiple === "Multiple Choice",
        max_multiple:
          data.multiple === "Multiple Choice" ? +data.max_multiple.value : null,
      },
      subDomain: getSubdomain(),
    });
  };

  const onOptionCreate = (data) => {
    const cost =
      typeof data.item_cost === "string"
        ? +data.item_cost.slice(1)
        : data.item_cost;

    const payload = {
      name: data.item_title,
      visible: data.item_active === "Active",
      cost,
      note: data.item_note,
      group_id: groupId,
    };
    createOption({ data: payload, subDomain: getSubdomain() });
  };

  const onOptionSaveEdit = (data) => {
    const cost =
      typeof data.item_cost === "string"
        ? +data.item_cost.slice(1)
        : data.item_cost;

    updateOption({
      id: optionId,
      data: {
        group_id: groupId,
        name: data.item_title,
        visible: data.item_active === "Active",
        cost,
        note: data.item_note,
      },
      subDomain: getSubdomain(),
    });
  };

  const openImageModal = (rowData) => () => {
    if (rowData.item.image_name) {
      setCurrentImage(
        `https://dwtl.food/public/images/${rowData.item.image_name}`
      );
    } else {
      setCurrentImage(NoImg);
    }
    setOptionId(rowData.item.id);
    setGroupId(rowData.group.group.group_id);
    setShowImageModal(true);
    setMenuItem(rowData);
  };

  const onImageSelect = (e) => {
    setCurrentImage(e.files[0].objectURL);
  };

  const onImageUpload = (e) => {
    uploadImage({
      id: selectedStation.id,
      subdomain: getSubdomain(),
      data: e.files[0],
      optionId: optionId,
      groupId: groupId,
    });
  };

  const moveGroupUp = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: selectedStation.id,
    };

    let move = false;

    groups.toReversed().forEach((item, index, array) => {
      if (move) {
        payload.groups.unshift({
          id: array[index].group.group_id,
          order: array.length - index,
        });

        payload.groups.unshift({
          id: array[index - 1].group.group_id,
          order: array.length - index - 1,
        });

        move = false;
      } else {
        if (item.group.group_id !== group.group.group_id) {
          payload.groups.unshift({
            id: item.group.group_id,
            order: array.length - index - 1,
          });
        } else {
          move = true;
        }
      }
    });
    setOpenedAcc(null);
    saveGroupOrder({
      payload,
      subDomain: getSubdomain(),
    });
  };

  const moveGroupDown = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: selectedStation.id,
    };
    setOpenedAcc(null);
    let move = false;
    groups.forEach((item, index, array) => {
      if (move) {
        payload.groups.push({
          id: array[index].group.group_id,
          order: payload.groups.length,
        });
        payload.groups.push({
          id: array[index - 1].group.group_id,
          order: payload.groups.length,
        });
        move = false;
      } else {
        if (item.group.group_id !== group.group.group_id) {
          payload.groups.push({
            id: item.group.group_id,
            order: payload.groups.length,
          });
        } else {
          move = true;
        }
      }
    });
    saveGroupOrder({ payload, subDomain: getSubdomain() });
  };

  const onDeleteGroup = () => {
    deleteOptionGroup({
      id: groupId,
      subDomain: getSubdomain(),
    });
  };

  const onDeleteOption = () => {
    deleteOption({ id: optionId, subdomain: getSubdomain() });
  };
  
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (groupMode === "create") {
        handleSubmit(onCreate)();
      } else {
        handleSubmit(onSaveEdit)();
      }
    }
  };
  
  const handleKeyDown2 = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if(optionMode === "create") {
        handleSubmit2(onOptionCreate)();
      } else {
        handleSubmit2(onOptionSaveEdit)();
      }
    }
  }
  
  const itemTemplate = (rowData) => (item) => {
    return (
      <div className={styles.stationOptionItem}>
        <div className={styles.column1}>
          <i className="pi pi-align-justify"></i>
        </div>
        <div style={{ width: "291px" }}>{item.name}</div>
        <div
          style={{ width: "133px", display: "flex", justifyContent: "center" }}
          onClick={openImageModal({ group: rowData, item })}
        >
          <div
            style={{
              background: `url(https://dwtl.food/public/images/${item.image_name}) 0% 0% / cover, url(${NoImg}) 0% 0% / cover`,
            }}
            className={styles.optionImage}
          ></div>
          <i className={`pi pi-pencil ${styles.imageEdit}`} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexShrink: 0,
            width: "123px",
            gap: "2px",
          }}
        >
          $ {item.cost.toFixed(2)}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            flexShrink: 0,
            width: "301px",
            gap: "2px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {item.note}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexShrink: 0,
            width: "130px",
          }}
        >
          {item.visible ? (
            <Button
              icon="pi pi-eye"
              className={`p-button-text ${styles.activeBtn}`}
              size="large"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible === "Active",
                  },
                  subDomain: getSubdomain(),
                });
              }}
            />
          ) : (
            <Button
              icon="pi pi-eye-slash"
              className={`p-button-text ${styles.activeBtn}`}
              size="large"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible !== "Active",
                  },
                  subDomain: getSubdomain(),
                });
              }}
            />
          )}
        </div>
        <div
          style={{
            width: "174px",
            textAlign: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <div className={styles.optionActionsWrapper}>
            <Button
              icon="pi pi-pencil"
              className={`p-button-text ${styles.editOptionBtn}`}
              onMouseDown={openItemModal("edit", item, rowData)}
            />
            <Button
              icon="pi pi-trash"
              className={`p-button-text ${styles.deleteOptionBtn}`}
              onMouseDown={openOptionDeleteModal(item)}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.pageHeader}>
        <h2>Menu Items</h2>
        {isGetStationsSuccess && (
            <Dropdown
              value={selectedStation}
              onChange={(e) => setSelectedStation(e.value)}
              options={stations?.toSorted((a, b) =>
                a.name.localeCompare(b.name)
              )}
              optionLabel="name"
              placeholder="Station"
              className={`${styles.dropdown}`}
            />
        )}
      </div>
      <div className={styles.groupActions}>
        {selectedStation && (
          <>
            <Button
              className={styles.createGroupBtn}
              onClick={openGroupModal("create")}
            >
              <i className="pi pi-plus" />{" "}
              <span className={styles.createBtnText}>ADD OPTION GROUP</span>
            </Button>
            <div className={styles.expandToggleWrapper}>
              <Button
                icon="pi pi-angle-down"
                label="EXPAND ALL"
                className={`p-button-text ${styles.expandButton}`}
                onClick={() => {
                  setOpenedAcc(
                    stationOptions?.length
                      ? stationOptions.map((_, index) => index)
                      : null
                  );
                }}
              />

              <Button
                icon="pi pi-angle-up"
                label="COLLAPSE ALL"
                className={`p-button-text ${styles.collapseButton}`}
                onClick={() => {
                  setOpenedAcc(null);
                }}
              />
            </div>
          </>
        )}
      </div>
      {selectedStation ? (
        <div className={styles.accordion}>
          {isGetStationOptionsSuccess && (
            <Accordion
              activeIndex={openedAcc}
              multiple
              onTabClose={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
              onTabOpen={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
              onTabChange={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
            >
              {stationOptions.map((item, index, array) => {
                return (
                  <AccordionTab
                    key={`${item.group.group_id}-${isMobile ? 'mobile' : 'desktop'}`}
                    header={
                      <div className={styles.accordionHeader}>
                        <div>
                          <span>{item.group.group_name}</span>
                          {/*{"  "}*/}
                          {/*<span>*/}
                          {/*  {item.group.allow_multiple === 1*/}
                          {/*    ? `( Multiple Choice MAX ${item.group.max_multiple} )`*/}
                          {/*    : "( Single Choice)"}*/}
                          {/*</span>*/}
                        </div>

                        <div className={styles.groupActionsWrapper}>
                          <div>
                            <Button
                              icon="pi pi-arrow-up"
                              className={`p-button-text ${styles.orderBtn}`}
                              disabled={index === 0}
                              onMouseDown={moveGroupUp(item, array)}
                            />
                            <Button
                              icon="pi pi-arrow-down"
                              className={`p-button-text ${styles.orderBtn}`}
                              disabled={array.length - 1 === index}
                              onMouseDown={moveGroupDown(item, array)}
                            />
                          </div>
                          <div>
                            <Button
                              icon="pi pi-plus"
                              className={`p-button-text ${styles.addOptionBtn}`}
                              onMouseDown={openItemModal("create", item.group)}
                            />
                            <Button
                              icon="pi pi-pencil"
                              className={`p-button-text ${styles.editGroupBtn}`}
                              onMouseDown={openGroupModal("edit", item.group)}
                            />
                            <Button
                              icon="pi pi-trash"
                              className={`p-button-text ${styles.deleteGroupBtn}`}
                              onMouseDown={openGroupDeleteModal(item.group)}
                            />
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div key={isMobile ? 'mobile' : 'desktop'}>
                      {isMobile ? (
                        <div className={styles.cardList}>
                          <Button className={styles.createBtn} onClick={openItemModal("create", item.group)}>
                            <i className="pi pi-plus" />
                          </Button>
                          {item.items.map(option => {
                            console.log(option.image_name)
                            
                            return (
                              <div
                                key={option.id}
                                className={styles.cardItem}
                              >
                                <div className={styles.cardInfo}>
                                  <div
                                    style={{
                                      backgroundImage: `url(https://dwtl.food/public/images/${option.image_name})`,
                                    }}
                                    className={styles.cardImage}
                                    onClick={openImageModal({ group: item, item: option })}
                                  >
                                    <div>
                                      <i className='pi pi-pencil'></i>
                                    </div>
                                  </div>
                                  <div className={styles.info}>
                                    <div className={styles.name}>{option.name}</div>
                                    <div className={styles.subfield}>
                                      Cost: <em>${option.cost}</em>
                                    </div>
                                    <div className={styles.subfield}>{option.note}</div>
                                  </div>
                                </div>
                                <div className={styles.actions}>
                                  {option.visible ? (
                                    <button
                                      className={styles.cardEditBtn}
                                      onClick={() => {
                                        updateOption({
                                          id: option.id,
                                          data: {
                                            group_id: item.group.group_id,
                                            visible: false,
                                          },
                                          subDomain: getSubdomain(),
                                        });
                                      }}
                                    >
                                      <i className='pi pi-eye' />
                                    </button>
                                  ) : (
                                    <button
                                      className={styles.cardEditBtn}
                                      onClick={() => {
                                        updateOption({
                                          id: option.id,
                                          data: {
                                            group_id: item.group.group_id,
                                            visible: true,
                                          },
                                          subDomain: getSubdomain(),
                                        });
                                      }}
                                    >
                                      <i className='pi pi-eye-slash' />
                                    </button>
                                  )}
                                  <button
                                    className={styles.cardEditBtn}
                                    onClick={openItemModal('edit', option, item.group)}
                                  >
                                    <i className='pi pi-pencil' />
                                  </button>
                                  <button
                                    className={styles.cardDeleteBtn}
                                    onClick={openOptionDeleteModal(option)}
                                  >
                                    <i className='pi pi-trash' />
                                  </button>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        <div className={styles.listWrapper}>
                          <OrderList
                            key={`order-${isMobile}`}
                            dataKey="id"
                            value={item.items}
                            onChange={(e) => {
                              saveOptionsOrder({
                                payload: {
                                  options: e.value.map((item, index) => {
                                    return { id: item.id, order: index + 1 };
                                  }),
                                  group_id: item.group.group_id,
                                },
                                subDomain: getSubdomain(),
                              });
                            }}
                            header={
                              <div className={styles.header}>
                                <div className={styles.column1}></div>
                                <div style={{ width: "291px" }}>Title</div>
                                <div
                                  style={{
                                    width: "133px",
                                    textAlign: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  Image
                                </div>
                                <div
                                  style={{
                                    width: "123px",
                                    textAlign: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  Cost
                                </div>
                                <div
                                  style={{
                                    width: "301px",
                                    textAlign: "start",
                                    flexShrink: 0,
                                  }}
                                >
                                  Note
                                </div>
                                <div
                                  style={{
                                    width: "130px",
                                    textAlign: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  Active
                                </div>
                                <div
                                  style={{
                                    width: "174px",
                                    textAlign: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  Actions
                                </div>
                              </div>
                            }
                            itemTemplate={itemTemplate(item)}
                            dragdrop
                            className={styles.orderListItem}
                          ></OrderList>
                        </div>
                      )}
                    </div>
                  </AccordionTab>
                );
              })}
            </Accordion>
          )}

          {/* Group Modal */}
          <Dialog
            header={`${groupMode === "create" ? "New" : "Edit"} Option Group`}
            visible={showGroupModal}
            onHide={() => {
              setShowGroupModal(false);
            }}
            footer={() => (
              <div className="flex gap-2 justify-content-end">
                <Button
                  label="Save"
                  type="submit"
                  className={`p-button-success ${styles.saveBtn}`}
                  onClick={
                    groupMode === "create"
                      ? handleSubmit(onCreate)
                      : handleSubmit(onSaveEdit)
                  }
                />
              </div>
            )}
            className={`p-fluid ${styles.groupModal}`}
          >
            <form key={1}>
              <Controller
                name="multiple"
                control={control}
                render={({ field }) => (
                  <SelectButton
                    {...field}
                    options={["Single Choice", "Multiple Choice"]}
                    allowEmpty={false}
                    className={`mb-5 ${styles.selectButton}`}
                  />
                )}
              />

              <Controller
                name="title"
                control={control}
                render={({ field }) => (
                  <div className="field">
                    <label>Title</label>
                    <InputText
                      {...field}
                      placeholder="Title"
                      onKeyDown={handleKeyDown}
                      className={`w-full ${styles.input}`}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                )}
              />

              {multiple === "Multiple Choice" && (
                <Controller
                  name="max_multiple"
                  control={control}
                  rules={{
                    validate: (e) => {
                      if (e.value === null) return "This field is required";
                      if (e.value < 2) return "Must be 2 or more";
                    },
                  }}
                  defaultValue={{ value: 2 }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="field mt-5">
                        <label>Max choice</label>
                        <InputNumber
                          {...field}
                          className={`w-full ${styles.numberInput}`}
                          value={field.value.value}
                          onKeyDown={handleKeyDown}
                          onChange={(e) => {
                            field.onChange({ value: e.value });
                          }}
                        />
                        {fieldState.error && (
                          <small className={`p-error `}>
                            {fieldState.error.message}
                          </small>
                        )}
                      </div>
                    );
                  }}
                />
              )}
            </form>
          </Dialog>

          {/* Delete group modal */}
          <Dialog
            closable={false}
            header={
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "30px",
                }}
              >
                Are You Sure?
              </div>
            }
            visible={showDeleteGroupModal}
            onHide={() => {
              setShowDeleteGroupModal(false);
            }}
            footer={() => (
              <div className="flex flex-column gap-2 justify-content-end">
                <Button
                  label="Delete"
                  className={`p-button-success ${styles.deleteDialogBtn}`}
                  onClick={onDeleteGroup}
                />
                <Button
                  label="Cancel"
                  text
                  className={`p-button-success ${styles.cancelDialogBtn}`}
                  onClick={() => {
                    setShowDeleteGroupModal(false);
                  }}
                />
              </div>
            )}
            className={`p-fluid ${styles.groupDeleteModal}`}
          >
            <div className={styles.text}>
              <span>
                You want to delete option group <strong>{groupName}</strong>.
              </span>
              Confirm this action by pressing ‘Delete’ or cancel it.
            </div>
          </Dialog>

          {/* Delete option modal */}
          <Dialog
            closable={false}
            header={
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "30px",
                }}
              >
                Are You Sure?
              </div>
            }
            visible={showDeleteOptionModal}
            onHide={() => {
              setShowDeleteOptionModal(false);
            }}
            footer={() => (
              <div className="flex flex-column gap-2 justify-content-end">
                <Button
                  label="Delete"
                  className={`p-button-success ${styles.deleteDialogBtn}`}
                  onClick={onDeleteOption}
                />
                <Button
                  label="Cancel"
                  text
                  className={`p-button-success ${styles.cancelDialogBtn}`}
                  onClick={() => {
                    setShowDeleteOptionModal(false);
                  }}
                />
              </div>
            )}
            className={`p-fluid ${styles.groupDeleteModal}`}
          >
            <div className={styles.text}>
              <span>
                You want to delete option <strong>{optionName}</strong>.
              </span>
              Confirm this action by pressing ‘Delete’ or cancel it.
            </div>
          </Dialog>

          {/* Option Modal */}
          <Dialog
            header={`${
              optionMode === "create" ? "New" : "Edit"
            } Menu Item Within ${groupName}`}
            visible={showOptionModal}
            onHide={() => {
              setShowOptionModal(false);
            }}
            footer={() => (
              <div className="flex gap-2 justify-content-end">
                <Button
                  label="Save"
                  type="submit"
                  className={`p-button-success ${styles.saveBtn}`}
                  onClick={
                    optionMode === "create"
                      ? handleSubmit2(onOptionCreate)
                      : handleSubmit2(onOptionSaveEdit)
                  }
                />
              </div>
            )}
            className={`p-fluid ${styles.groupModal}`}
          >
            <form key={2}>
              <Controller
                name="item_title"
                control={control2}
                render={({ field }) => (
                  <div className="field">
                    <label>Title</label>
                    <InputText
                      className={`w-full mb-3 ${styles.input}`}
                      {...field}
                      placeholder="Title"
                      onKeyDown={handleKeyDown2}
                    />
                  </div>
                )}
              />

              <Controller
                name="item_cost"
                control={control2}
                render={({ field }) => {
                  return (
                    <div className="field">
                      <label>Cost</label>
                      <InputNumber
                        className={`w-full mb-3 ${styles.numberInput}`}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        prefix="$"
                        {...field}
                        value={+field.value || null}
                        onKeyDown={handleKeyDown2}
                        onChange={(e) => {
                          field.onChange(e.value);
                        }}
                        onChangeCapture={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    </div>
                  );
                }}
              />

              <Controller
                name="item_note"
                control={control2}
                render={({ field }) => (
                  <div className="field">
                    <label>Note</label>
                    <InputTextarea
                      className={`w-full mb-3 ${styles.textarea}`}
                      onKeyDown={handleKeyDown2}
                      {...field}
                    />
                  </div>
                )}
              />

              <Controller
                name="item_active"
                control={control2}
                render={({ field }) => (
                  <SelectButton
                    {...field}
                    options={["Active", "Inactive"]}
                    allowEmpty={false}
                    className={styles.selectButton}
                  />
                )}
              />
            </form>
          </Dialog>

          {/* Image modal */}
          <Dialog
            header={`Item Image`}
            visible={showImageModal}
            onHide={() => {
              setShowImageModal(false);
            }}
            footer={() => (
              <div className="flex gap-2 justify-content-end">
                <FileUpload
                  mode="basic"
                  onSelect={onImageSelect}
                  customUpload
                  uploadHandler={onImageUpload}
                  onUpload={() => {}}
                  accept="image/*"
                  selectedFileLabel="Upload"
                  className={styles.uploadBtn}
                />
              </div>
            )}
            className={`p-fluid ${styles.imageModal}`}
          >
            <form>
              <div className={styles.preview}>
                <div className={styles.cardWrapper}>
                  <div className={styles.optionCard}>
                    <div
                      style={{
                        backgroundImage: `url(${currentImage})`,
                      }}
                      className={styles.image}
                    ></div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>
        </div>
      ) : (
        <div>Select station please</div>
      )}
    </div>
  );
};

export default MenuItems;
